import { _ as __assign } from '../../chunks/bundle-BsoKutlt.js';
import React__default from 'react';
import { S as SuggestedMentionListView } from '../../chunks/bundle-D8_eHC2p.js';
import '../../chunks/bundle-C8lF82nA.js';
import '../../chunks/bundle-D9fAlnnY.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-By8wnYCK.js';
import '../../chunks/bundle-DFFEB3Ap.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-Bpnh459j.js';
import '../../chunks/bundle-BXx8qybA.js';
import '../../chunks/bundle-K-ZPPQr-.js';
import '../../chunks/bundle-Bect-58W.js';
import '../../useSendbirdStateContext.js';
import '../../withSendbird.js';
import '../../chunks/bundle-Cdxj4urY.js';
import '../../chunks/bundle-CkidI9AN.js';

var SuggestedMentionList = function (props) {
    return (React__default.createElement(SuggestedMentionListView, __assign({}, props)));
};

export { SuggestedMentionList, SuggestedMentionList as default };
//# sourceMappingURL=SuggestedMentionList.js.map
